import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=67b4b88a&scoped=true&"
var script = {}
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=67b4b88a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4b88a",
  null
  
)

export default component.exports